import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const Info = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="Info" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2z"
        fill="currentColor"
      />
      <path stroke="currentColor" strokeWidth="2" d="M12 10v8" />
      <circle cx="12" cy="6.5" r="1.5" fill="currentColor" />
    </SvgIcon>
  );
};
